import { merchantApi } from '@/config/axios'

export interface DeliveryExpressTemplateVO {
  id?: number
  name: string
  chargeMode: number
  sort: number
  charges: ExpressTemplateChargeVO[]
  frees: ExpressTemplateFreeVO[]
}

export declare type ExpressTemplateChargeVO = {
  areaIds: number[]
  startCount: number
  startPrice: number
  extraCount: number
  extraPrice: number
}

export declare type ExpressTemplateFreeVO = {
  areaIds: number[]
  freeCount: number
  freePrice: number
}

// 查询快递运费模板分页（商家端）
export const getDeliveryExpressTemplatePage = async (params: PageParam) => {
  return await merchantApi.get<PageResult<DeliveryExpressTemplateVO[]>>({
    url: '/merchant-api/trade/delivery/express-template/page',
    params
  })
}

// 查询快递运费模板详情（商家端）
export const getDeliveryExpressTemplate = async (id: number) => {
  return await merchantApi.get<DeliveryExpressTemplateVO>({
    url: '/merchant-api/trade/delivery/express-template/get?id=' + id
  })
}

// 查询精简模板列表（商家端，用于下拉选项）
export const getSimpleTemplateList = async () => {
  return await merchantApi.get<DeliveryExpressTemplateVO[]>({
    url: '/merchant-api/trade/delivery/express-template/list-all-simple'
  })
}

// 新增快递运费模板（商家端）
export const createDeliveryExpressTemplate = async (data: DeliveryExpressTemplateVO) => {
  return await merchantApi.post({ url: '/merchant-api/trade/delivery/express-template/create', data })
}

// 修改快递运费模板（商家端）
export const updateDeliveryExpressTemplate = async (data: DeliveryExpressTemplateVO) => {
  return await merchantApi.put({ url: '/merchant-api/trade/delivery/express-template/update', data })
}

// 删除快递运费模板（商家端）
export const deleteDeliveryExpressTemplate = async (id: number) => {
  return await merchantApi.delete({ url: '/merchant-api/trade/delivery/express-template/delete?id=' + id })
}
